import React, { Fragment, useState } from 'react';
import Header from '../../components/Header/Header';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/business/Footer/Footer';
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "reactstrap";
import FAQBg from "../../images/backgrounds/faq_bg_image.webp";
const PrivacyPolicy = (props) => {

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };
    return (
        <Fragment>
            <Header />
            <main className="page_content ">
                <PageTitle
                    pageTitle={'Privacy Policy'}
                    bgImage={FAQBg}
                />
                <section className="intro_about_section section_space">
                    <div className="container">
                        <div className="heading_block mb-0">
                            <div className="row justify-content-lg-between">
                                <div className="col-lg-4">
                                    <h2 className="heading_text mb-0">
                                        Privacy Policy
                                    </h2>
                                </div>
                                <div className="col-lg-6">
                                    <p className="heading_description mb-0">
                                        Welkom bij het Privacybeleid van Praeventor. Bij Praeventor hechten we veel waarde aan de privacy en bescherming van de gegevens van onze klanten en bezoekers. In dit document leggen we uit welke persoonlijke gegevens we verzamelen, waarom we deze gegevens verzamelen, en hoe we ervoor zorgen dat deze veilig en vertrouwelijk worden behandeld. We voldoen aan de relevante privacywetgeving, waaronder de Algemene Verordening Gegevensbescherming (AVG), en nemen alle noodzakelijke maatregelen om uw gegevens te beschermen.
                                        </p>
                                    <p className="heading_description mb-0">
                                        We raden u aan dit beleid zorgvuldig door te lezen om volledig op de hoogte te zijn van onze werkwijze omtrent gegevensverzameling en -bescherming. Heeft u vragen of wilt u meer weten? Neem gerust contact met ons op – we staan altijd klaar om te helpen.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: "200px"}}>
                            <div>
                                <div className="faq_accordion accordion" id="faq_accordion">
                                    <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="1">
                                                1. Inleiding
                                            </AccordionHeader>
                                            <AccordionBody accordionId="1" className="acc_body">
                                                <p>
                                                    Dit Privacybeleid beschrijft hoe Praeventor Security Technology ("Praeventor", "wij", "ons" of "onze") omgaat met uw persoonsgegevens. We zetten ons in voor de bescherming van uw privacy en het naleven van de Algemene Verordening Gegevensbescherming (AVG) en andere relevante wet- en regelgeving. Dit beleid legt uit welke informatie we verzamelen, hoe we deze gebruiken en welke rechten u heeft met betrekking tot uw gegevens.
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>

                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="2">
                                                2. Welke Gegevens Wij Verzamelen
                                            </AccordionHeader>
                                            <AccordionBody accordionId="2" className="acc_body">
                                                <p>
                                                    Wij kunnen de volgende soorten gegevens verzamelen:
                                                    <ul>
                                                        <li><strong>Persoonlijke Identificatiegegevens:</strong> zoals uw naam, e-mailadres, telefoonnummer en bedrijfsnaam.</li>
                                                        <li><strong>Technische Gegevens:</strong> zoals IP-adressen, browsertype, apparaatidentificaties en andere gegevens die worden verzameld via cookies en soortgelijke technologieën.</li>
                                                        <li><strong>Gebruiksgegevens:</strong> informatie over hoe u onze website en diensten gebruikt, zoals bezochte pagina’s en aanklikken van links.</li>
                                                        <li><strong>Financiële Gegevens:</strong> bij het afsluiten van een dienst kunnen wij facturatiegegevens zoals factuuradres en betalingsinformatie verwerken.</li>
                                                    </ul>
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>

                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="3">
                                                3. Hoe Wij Uw Gegevens Gebruiken
                                            </AccordionHeader>
                                            <AccordionBody accordionId="3" className="acc_body">
                                                <p>
                                                    Wij gebruiken uw gegevens voor de volgende doeleinden:
                                                    <ul>
                                                        <li>Het leveren en verbeteren van onze diensten en producten.</li>
                                                        <li>Het beheren van klantenrelaties en communicatie, inclusief het beantwoorden van vragen en het verstrekken van informatie.</li>
                                                        <li>Het uitvoeren van analyses om onze dienstverlening te optimaliseren.</li>
                                                        <li>Het voldoen aan wettelijke verplichtingen en bescherming van onze rechten en die van onze klanten.</li>
                                                    </ul>
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>

                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="4">
                                                4. Delen van Gegevens met Derden
                                            </AccordionHeader>
                                            <AccordionBody accordionId="4" className="acc_body">
                                                <p>
                                                    Wij delen uw gegevens uitsluitend met derden indien dit noodzakelijk is voor het leveren van onze diensten of indien wij hiertoe wettelijk verplicht zijn. Derden die toegang kunnen krijgen tot uw gegevens zijn onder meer:
                                                    <ul>
                                                        <li><strong>IT- en cloudleveranciers:</strong> om onze infrastructuur te ondersteunen.</li>
                                                        <li><strong>Betaalverwerkers:</strong> om betalingen veilig af te handelen.</li>
                                                        <li><strong>Adviseurs en juridische partners:</strong> indien noodzakelijk voor juridische of administratieve ondersteuning.</li>
                                                    </ul>
                                                    Wij zorgen ervoor dat deze partijen voldoen aan dezelfde privacystandaarden als Praeventor.
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>

                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="5">
                                                5. Bewaartermijn van Gegevens
                                            </AccordionHeader>
                                            <AccordionBody accordionId="5" className="acc_body">
                                                <p>
                                                    Uw gegevens worden niet langer bewaard dan noodzakelijk voor de doeleinden waarvoor ze zijn verzameld, tenzij een langere bewaartermijn vereist is door wet- of regelgeving. In de meeste gevallen bewaren wij persoonsgegevens voor de duur van de klantrelatie en tot maximaal 2 jaar daarna voor administratieve doeleinden.
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>

                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="6">
                                                6. Beveiliging van Gegevens
                                            </AccordionHeader>
                                            <AccordionBody accordionId="6" className="acc_body">
                                                <p>
                                                    Praeventor neemt passende technische en organisatorische maatregelen om uw gegevens te beschermen tegen ongeautoriseerde toegang, verlies of diefstal. Dit omvat het gebruik van versleuteling, toegangscontrole, en het periodiek testen van onze beveiligingsprotocollen.
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>

                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="7">
                                                7. Uw Rechten
                                            </AccordionHeader>
                                            <AccordionBody accordionId="7" className="acc_body">
                                                <p>
                                                    U heeft het recht om uw persoonsgegevens in te zien, te corrigeren, te verwijderen of de verwerking ervan te beperken. Daarnaast kunt u bezwaar maken tegen de verwerking van uw gegevens en het recht uitoefenen op gegevensoverdraagbaarheid. Neem contact met ons op via [contactgegevens] om een verzoek in te dienen.
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>

                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="8">
                                                8. Wijzigingen in dit Privacybeleid
                                            </AccordionHeader>
                                            <AccordionBody accordionId="8" className="acc_body">
                                                <p>
                                                    Praeventor kan dit Privacybeleid van tijd tot tijd wijzigen om te blijven voldoen aan de wetgeving of om onze praktijken te verbeteren. Wij raden u aan deze pagina regelmatig te raadplegen om op de hoogte te blijven van wijzigingen. Belangrijke wijzigingen zullen via e-mail of onze website worden gecommuniceerd.
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>

                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="9">
                                                9. Contactinformatie
                                            </AccordionHeader>
                                            <AccordionBody accordionId="9" className="acc_body">
                                                <p>
                                                    Heeft u vragen over dit Privacybeleid of wilt u een verzoek indienen met betrekking tot uw rechten? Neem dan contact op met ons via:
                                                    <br />E-mail: info@praeventor.nl
                                                    <br />Telefoon: +31 6 27 46 80 33
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>

                                    </Accordion>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default PrivacyPolicy;
